/* eslint-disable react-hooks/exhaustive-deps */
import { decodeHtml } from "@/utils/helpers";
import axios from "axios";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { GlobalContext } from "./context/Global";


interface CaseStudiesProps {
  type?: number;
  categoryId?: number;
  refresh?: boolean;
  level?: number;
  industryCategories?: any[];
}

const CaseStudies = ({
  type,
  categoryId,
  refresh,
  level,
  industryCategories
}: CaseStudiesProps) => {
  const router = useRouter();
  const [caseStudy, setCaseStudy] = useState<any>([]);
  const { userCountry, country } = useContext<any>(GlobalContext);

  useEffect(() => {
    let industryCategory = router?.asPath?.split(/#/)[1];
    // industryCategory = industryCategory ? industryCategory[0].toUpperCase() + industryCategory.slice(1): ''

    console.log("countryName :", country);
    if (userCountry === "countryNotFound") {
      loadCaseStudy(null, industryCategory);
    } else if (userCountry) {
      loadCaseStudy(userCountry, industryCategory);
    }
  }, [router, refresh, userCountry]);

  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []); 

  const loadCaseStudy = async (country: any, industry: string) => {
    const getKey = level === 1 ? "ServiceLevel1" : "ServiceLevel2";
    let filterQuery = ''
    industryCategories?.map((ind: any, index: number) => {
      filterQuery += `&filters[Industries][slug][$in][${index}]=${ind?.attributes?.slug}`
    })
    const url = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/api/case-studies?populate=*` +
      `${categoryId ? `&filters[${getKey}][id]=${categoryId}` : ""}` +
      `${country ? `&filters[Localisation][$contains]=${country}` : ""}` +
      `${industryCategories?.length ? filterQuery : ''}` +
      `${industry ? `&filters[Industries][slug]=${industry}` : ""}` +
      `&sort[5]=id:desc&pagination[pageSize]=999999`;
    await axios
      .get(
        url,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        if (res?.data?.data?.length >= 5)
          setCaseStudy(res?.data?.data.slice(0, 5));
        else loadMore(res?.data?.data, industry);
      });
  };

  const loadMore = async (data: [], industry: string) => {
    const getKey = level === 1 ? "ServiceLevel1" : "ServiceLevel2";
    const filterQuery = data
      .map(
        (item: any, index: number) => `filters[id][$notIn][${index}]=${item.id}`
      )
      .join("&");

    await axios
      .get(
        `${process.env.NEXT_PUBLIC_STRAPI_API_URL
        }/api/case-studies?populate=*&filters[${getKey}][id]=${categoryId}&${filterQuery}${industry ? `filters[Industries][slug]=${industry}` : ""
        }&sort[5]=id:desc&pagination[pageSize]=${5 - data.length}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        const updatedList: any = [...data, ...res?.data?.data];
        if (updatedList?.length >= 5) {
          setCaseStudy([...data, ...res?.data?.data]);
        } else {
          loadMoreCaseStudy(updatedList);
        }
      });
  };
  const loadMoreCaseStudy = async (data: []) => {
    const filterQuery = data
      .map(
        (item: any, index: number) =>
          `&filters[id][$notIn][${index}]=${item.id}`
      )
      .join("&");

    await axios
      .get(
        `${process.env.NEXT_PUBLIC_STRAPI_API_URL
        }/api/case-studies?populate=*${filterQuery}&sort[5]=id:desc&pagination[pageSize]=${5 - data.length
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        setCaseStudy([...data, ...res?.data?.data]);
      });
  };

  return caseStudy?.length > 0 ? (
    <div className="casestudies">
      <Container>
        <Row>
          <Col xs={12}>
            <h2 className="heading case-mb-4">Case Studies</h2>
          </Col>
          <Col md={12} lg={type === 1 ? 12 : 8}>
            <div className="scale-container">
              <div
                className="box first-row pointer"
                onClick={(e) => {
                  if (e.ctrlKey)
                    window.open(
                      `/resources/case-studies/${caseStudy[0]?.attributes?.Slug}`,
                      "_target"
                    );
                  else
                    router.push(
                      `/resources/case-studies/${caseStudy[0]?.attributes?.Slug}`
                    );
                }}
              >
                <div
                  className="bg-scale-img"
                  style={{
                    backgroundImage: `url(${caseStudy[0]?.attributes?.Banner?.data?.attributes
                      ?.formats?.medium?.url ||
                      caseStudy[0]?.attributes?.BannerImageURL
                      })`,
                  }}
                ></div>
                <div className="text-content">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="flex-1 me-2">
                      <h3>{decodeHtml(caseStudy[0]?.attributes?.Title)}</h3>
                      <p>{caseStudy[0]?.attributes?.ShortDescription}</p>
                    </div>
                    {/* <ButtonIcon
                      link={`/resources/case-studies/${caseStudy[0]?.attributes?.Slug}`}
                      bgClass="blue-link"
                      iconType="white"
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={6} lg={4} style={{ display: type === 1 ? "none" : "block" }}>
            <Link prefetch={false}
              href={`/resources/case-studies/${caseStudy[1]?.attributes?.Slug}`}
            >
              <div className="scale-container">
                <div className="box box-min-height first-row first-row-sec-item mt-3 mt-lg-0">
                  <div
                    className="bg-scale-img"
                    style={{
                      backgroundImage: `url(${caseStudy[1]?.attributes?.Banner?.data?.attributes
                        ?.formats?.medium?.url ||
                        caseStudy[1]?.attributes?.BannerImageURL
                        })`,
                    }}
                  ></div>
                  <div className="text-content">
                    <div className="d-flex  h-100 justify-content-between w-100 align-items-sm-end">
                      <h4 className="mb-0 mt-md-2">
                        {decodeHtml(caseStudy[1]?.attributes?.Title)}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
          {caseStudy?.slice(2)?.map((item: any) => (
            <Col xs={6} lg={4} key={item?.id}>
              <Link prefetch={false} href={`/resources/case-studies/${item?.attributes?.Slug}`}>
                <div className="scale-container mt-20">
                  <div className="box box-min-height second-row">
                    <div
                      className="bg-scale-img"
                      style={{
                        backgroundImage: `url(${item?.attributes?.Banner?.data?.attributes?.formats
                          ?.medium?.url || item?.attributes?.BannerImageURL
                          })`,
                      }}
                    ></div>
                    <div className="text-content">
                      <div className="d-flex h-100 justify-content-between w-100 align-items-sm-center">
                        <h4>{decodeHtml(item?.attributes?.Title)}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
          ))}
          <Col col={12}>
            <Button
              className=" cases-more-btn-btn"
              onClick={() => {
                router.push("/resources/case-studies/");
              }}
            >
              All Case Studies
            </Button>
          </Col>
        </Row>
      </Container>
      <div className="m-5">
        {/* <Button className="case-more-btn  float-right" onClick={() => { router.push('/resources/case-studies/') }}>Explore More Case Studies ➝</Button> */}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CaseStudies;
